import React, {Component} from "react";
import {
  Button,
  CircularProgress,
  Divider,
  Fab,
  Grid,
  Hidden,
  Icon,
  Modal,
  Radio,
  Typography
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import {connect} from "react-redux";
import Header from "../Header";
import {
  parentContainer,
  primaryColor,
  textBlack,
  textGrey,
  webFont
} from "../../config/theme";
import {getChefDetails} from "../../redux/chefs";
import { selectedChef, setPendingBooking, setSelectedDate, setSelectedSlot } from '../../redux/bookings';
import DishesList from "../Dishes/DishesListDinerView";
import SinglePost from "../Posts/SinglePost";
import InProgressBooking from "../Booking/InProgressBooking";
import {initialCart, setSelectedChefAndSlots} from "../../redux/bookings";
import IconButton from "@material-ui/core/IconButton/IconButton";
import {client} from "../../config/apollo";
import {FAV, UNFAV} from "../../graphql/mutations/user";
import {GET_CHEF_PAYMENT, GET_CHEF, GET_CHEF_DETAILS} from "../../graphql/queries/chef";
import {GET_SAVED_CHEFS} from "../../graphql/queries/user";
import {compose, graphql} from "react-apollo";
import moment from "moment";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { NotificationManager } from "react-notifications";
import Breadcrumbs from "../Breadcrumbs";

const defaultChefImg = "/images/simple-chef.webp";
const tick = "/images/tick.webp";

const CUSTOM_BOOKING = 'CUSTOM_BOOKING';
const DISHES_BOOKING = 'DISHES_BOOKING';

class ChefDiner extends Component {
  state = {
    bookingDrawer: false,
    startBooking: false,
    selectedDishCount: -1,
    liked: false,
    reviews: [],
    viewAsDiner: false,
    selectedDishId: null,
    isCalledClick: false,
    isBookingModalOpen: false,
    isRecurring: false,
    bookingType: "",
    isCustomBookingModalOpen: false,
    repeatedDays: [],
    numberOfRepetitions: 1
  };

  componentDidMount() {
    this.props.dispatch(setSelectedChefAndSlots(null));
    if (!this.props.location.state) {
      return this.props.history.push("/home/dashboard");
    }

    let selectedDishId = null;

    const {
      location: {
        state: {chefId, viewAsDiner},
        search,
      },
      dispatch, pendingBooking
    } = this.props;

    if (search) {
      const searchArr = search.split('=');
      if (searchArr.length > 1) {
        selectedDishId = searchArr[1];
      }
    }

    if (viewAsDiner) {
      this.setState({ viewAsDiner: true });
      dispatch(selectedChef(chefId));
      if (!!pendingBooking) {
        if (pendingBooking.chefId !== chefId) {
          dispatch(setPendingBooking(null, true));
        }
      }
    }

    let liked = false;

    client
      .query({
        query: GET_SAVED_CHEFS,
        variables: {
          userId: this.props.userId
        },
        fetchPolicy: "network-only"
      })
      .then(response => {
        const { savedChefs } = response.data;

        if (!!savedChefs && !!savedChefs.chefs && savedChefs.chefs.length > 0) {
          const index = savedChefs.chefs.findIndex(item => item.id === chefId);

          if (index > -1) {
            liked = true;
          }
          this.setState({ liked });
        }
      })
      .catch(err => console.error('ERR Fetching saved chefs'));

    dispatch(getChefDetails(chefId));

    dispatch(initialCart());
    dispatch(setSelectedSlot(null));

    this.setState({
      startBooking: true,
      selectedDishId
    });
  }

  callClick = dishId => {
    const {isCalledClick} = this.state;
    if (isCalledClick) return;

    this.setState({ isCalledClick: true }, () => {
      if (dishId) {
        const dishAddBtn = document.getElementById(`dish-item-${dishId}`);
        if (dishAddBtn) {
          dishAddBtn.click();
          this.props.dispatch(setSelectedDate(moment().add(3, 'hours').format('YYYY-MM-DD')));
          setTimeout(() => {
            this.toggleBookingDrawer();
          }, 1000);
        }
      }
    });
  };

  handleDishClick = dish => {
    const {isChef, userId, history} = this.props;
    if (isChef && userId === dish.chefId) {
      history.push("/home/add-dish", {dish});
    } else {
      history.push("/home/dish-details", {dishId: dish.id, viewAsDiner: this.state.viewAsDiner});
    }
  };

  handleClick = post => {
    const {history, userId, isChef} = this.props;
    if (isChef && userId === post.chefId) {
      history.push("/home/add-post", {post});
    } else {
      history.push("/home/post-details", {postId: post.id});
    }
  };

  addBookingData = () => {
    if (this.state.viewAsDiner) {
      NotificationManager.info('The diner will be taken to through the booking flow', 'Chef profile');
      return;
    }

    const {cart, dispatch, selectedChef, chefAvailibility} = this.props;
    const booking = {
      dishes: cart,
      chefId: selectedChef,
      chefAvailibility,
    };
  };

  toggleBookingDrawer = () => {
    if (this.state.viewAsDiner) {
      NotificationManager.info('The diner will be taken to through the booking flow', 'Chef profile');
      return;
    }

    if ((this.props.cart && this.props.cart.length) || this.state.bookingType === CUSTOM_BOOKING) {
      this.setState({
        bookingDrawer: !this.state.bookingDrawer
      });

      if (this.state.bookingType !== CUSTOM_BOOKING) { this.addBookingData(); }
    }
    this.setState({
      selectedDishCount: this.props.cart.length
    });
  };

  like = chefId => {
    const {savedChefs, userId} = this.props;
    let isFav = savedChefs && savedChefs.chefs && savedChefs.chefs.length > 0;
      if (this.state.liked || isFav) {
      client
      .mutate({
        mutation: UNFAV,
        variables: {
        userId,
        itemsToDelete: {chefs: [chefId]}
        }
      })
      .then(res => {
          this.setState({liked: false});
        })
        .catch(err => {
          console.log(err);
        });
      } else {
      client
      .mutate({
        mutation: FAV,
        variables: {
        userId,
        itemsToAdd: {chefs: [chefId]}
      } })
      .then(res => {
        this.setState({liked: true});
      })
      .catch(err => {
        console.log(err);
      });
    }
  };

  starRating = (rating) => {
    let ratingStars = '';
    if (rating > 0) {
      switch (rating) {
        case 1:
          ratingStars = <Icon className="star-icon">star_rate</Icon>;
          break;

        case 2:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 3:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 4:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 5:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;
      }
    } else {
      ratingStars = "";
    }

    return ratingStars;
  };

  createMarkup = (text) => {
    return {__html: text};
  };

  renderVideo = item => {
    return (
      <iframe
        src={item.embedUrl}
        width="212"
        height="212"
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen></iframe>);
  };

  renderImgItem = item => {
    return (
      <Grid item>
        <Hidden only={["xs", "lg", "xl"]}>
          <img
            data-test-id={"chefimg-id"}
            src={item.original}
            style={{...styles.chefImg, ...styles.chefImgIPad}}
          />
        </Hidden>
        <Hidden only={["sm", "md"]}>
          <img
            data-test-id={"chefimg-id"}
            src={item.original}
            style={{...styles.chefImg, ...styles.chefImgLg}}
          />
        </Hidden>
      </Grid>
    );
  };

  toggleBookingModal = isOpen => { this.setState({ isBookingModalOpen: isOpen }) };

  toggleCustomBookingModal = isOpen => { this.setState({ isCustomBookingModalOpen: isOpen }) };

  handleBookNow = (bookingType) => {
    const updatePayload = {bookingType};

    if (this.props.cart) {
      updatePayload.selectedDishCount = this.props.cart.length;
    }

    this.setState(updatePayload, () => {
      this.toggleBookingDrawer();
    });
    /*const { isRecurring, bookingType } = this.state;

    if (!isRecurring && bookingType === DISHES_BOOKING) {
      this.toggleBookingDrawer();
    } else { this.toggleBookingModal(true); }*/
    //this.toggleBookingDrawer();
  };

  selectBookingType = bookingType => { this.setState({ bookingType }) };

  chooseBookingSelection = () => {
    const { bookingType } = this.state;

    if (bookingType === DISHES_BOOKING) { this.toggleBookingModal(false); this.toggleBookingDrawer(); }
    if (bookingType === CUSTOM_BOOKING) {
      this.toggleBookingModal(false);
      this.toggleBookingDrawer();
      //this.toggleCustomBookingModal(true);
    }
  };

  render() {
    const {history, chef, isChef} = this.props;
    const {isCalledClick, selectedDishId} = this.state;

    if (!chef) {
      return (
        <Grid
          container
          alignItems={"center"}
          alignContent={"center"}
          style={{marginTop: 250, alignSelf: 'center', justifyContent: 'center'}}
        >
          <CircularProgress color={"primary"} size={100}/>
        </Grid>
      );
    }

    const imgItems = [];

    if (!!chef.media) {
      if (chef.media.length > 0) {
        chef.media.forEach(mItem => {
          if (mItem.size && mItem.type) {
            if  (mItem.type === 'PHOTO' && mItem.size !== 'SMALL_SQUARE_THUMBNAIL') {
              imgItems.push({
                original: mItem.url,
                originalAlt: chef.firstName,
                renderItem: this.renderImgItem
              });
            }
          }
        });
      } else {
        imgItems.push({
          original: defaultChefImg,
          renderItem: this.renderImgItem,
          originalAlt: chef.firstName,
        });
      }
    }

    if (chef.vimeoId && !!chef.s3) {
      if (chef.s3.processed) {
        imgItems.push({
          original: defaultChefImg,
          embedUrl: `https://player.vimeo.com/video/${chef.vimeoId}`,
          renderItem: this.renderVideo,
          originalAlt: chef.firstName,
        });
      }
    }

    let chefCuisines = "";
    chef.cuisines.forEach(cuisine => {
      chefCuisines += cuisine + ", ";
    });

    chefCuisines = chefCuisines.substr(0, chefCuisines.trim().length - 1);

    /*if (chef.cuisines.length > 3) {
      chefCuisines = "Multi Cuisines";
    }*/

    let chefRatings = 0;

    if (chef.rating) {
      if (chef.rating > 0) {
        chefRatings = Math.floor(chef.rating);
      }
    }

    const story = chef.story ? chef.story.replace(/\n/g, "<br />") : "<br />";

    let ratingStars = null;

    if (chefRatings > 0) {
      switch (chefRatings) {
        case 1:
          ratingStars = <Icon className="star-icon">star_rate</Icon>;
          break;

        case 2:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 3:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 4:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;

        case 5:
          ratingStars = (
            <div>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
              <Icon className="star-icon">star_rate</Icon>
            </div>
          );
          break;
      }
    } else {
      chefRatings = "";
    }


    const dishesList2 = (
      <DishesList
        type="dishesByChef"
        pageSize={50}
        filters={{chefId: chef.id}}
        next={null}
        isLiveShow={false}
        previous={null}
        {...this.props}
        viewAsDiner={this.state.viewAsDiner}
        updatedAt={null}
        refreshBookNow={() => this.setState({ viewAsDiner: false })}
        selectedDishId={selectedDishId}
        isCalledClick={isCalledClick}
        callClick={this.callClick}
      />
    );

    const postsList = chef.postsList.posts.length ? chef.postsList.posts.map((post, index) => {
      return (
        <Grid key={index.toString()} className="featured-post-item">
          <SinglePost
            key={index.toString()}
            post={post}
            index={index}
            page={"profile"}
            handleClick={this.handleClick}
            viewAsDiner={this.state.viewAsDiner}
          />
        </Grid>
      );
    }) : (
      <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
        No posts added yet.
      </div>
    );;

    const screen = this.props.location && this.props.location.state && this.props.location.state.screen ?
      this.props.location.state.screen : '';

    let childRoutes = [
      {
        display: 'Chef Details',
        link: 'home/chef-profile'
      },
    ];

    if (screen === 'saved') {
      childRoutes = [{
        display: 'Saved',
        link: 'home/saved'
      },{
        display: 'Chef Details',
        link: 'home/chef-profile'
      }];
    }
    if (screen === 'chef-search') {
      childRoutes = [{
        display: 'Chefs',
        link: 'home/chef-search'
      },{
        display: 'Chef Details',
        link: 'home/chef-profile'
      }];
    }
    if (this.state.viewAsDiner) {
      childRoutes = [{
        display: 'View As Diner',
        link: '#'
      }];
    }

    return (
      <div style={{...parentContainer, position: "relative"}}>
        <Grid container>
          <Grid item xs={12}>
            <Header history={history}/>
          </Grid>
        </Grid>

        <div className="profile-diner-container">
          <Grid item className="chef-detail-row" direction={'column'} lg={12} xs={12} xl={12} sm={12}>
            <Hidden smDown>
              <Grid item xs={12} style={{ marginBottom: 30 }}>
                <Breadcrumbs childRoutes={childRoutes} />
              </Grid>
            </Hidden>
            <Hidden mdUp>
              <Grid item xs={12} style={{ marginBottom: 30 }}>
                <Breadcrumbs childRoutes={childRoutes} />
              </Grid>
            </Hidden>
            <Grid className="chef-detail-container" container direction={'row'} lg={12} xs={12} xl={12} sm={12} justify={'space-between'}>
              <Grid className="chef-detailcol-left" item>
                <Grid container>
                  {imgItems.length > 0 ? (<ImageGallery
                    autoPlay={false}
                    items={imgItems}
                    lazyLoad={true}
                    infinte={true}
                    showBullets={true}
                    showFullscreenButton={false}
                    showNav={false}
                    showPlayButton={false}
                    showThumbnails={false}
                    showIndex={false}
                    slideDuration={450}
                    slideInterval={3500}
                  />) : (
                    <Grid item>
                      <Hidden only={["xs", "lg", "xl"]}>
                        <img
                          data-test-id={"chefimg-id"}
                          src={defaultChefImg}
                          style={{...styles.chefImg, ...styles.chefImgIPad}}
                        />
                      </Hidden>
                      <Hidden only={["sm", "md"]}>
                        <img
                          data-test-id={"chefimg-id"}
                          src={defaultChefImg}
                          style={{...styles.chefImg, ...styles.chefImgLg}}
                        />
                      </Hidden>
                    </Grid>
                  )}

                  <Grid data-test-id={"chefdet-id"} item direction={'column'} style={{display: 'flex', flex: 'auto', marginTop: 20, paddingLeft: 32}}>

                    <Typography
                      variant="h4"
                      style={{...styles.setFont, marginTop: 25, marginRight: 10, fontSize: 32, fontWeight: 500, position: 'relative'}}
                    >
                      {chef.firstName} {chef.lastName}
                      {chef.verified && <div style={{ position: 'absolute', top: -5, left: -25 }}>
                        <img src={tick} alt="Verified Chef" style={styles.tick} />
                      </div>}
                      {chef.numOfLikes > 0  && !this.state.viewAsDiner && (
                        <IconButton>
                          <Icon data-test-id={"cheflikes-id"} style={{ color: "#ff8000" }}>favorite</Icon>
                        </IconButton>
                      )}
                      {this.state.liked && !this.state.viewAsDiner && (
                        <IconButton onClick={() => this.like(chef.id)}>
                          <Icon data-test-id={"cheflikes-id"} style={{ color: "#ff8000" }}>favorite</Icon>
                        </IconButton>
                      )}
                      {!this.state.liked && !this.state.viewAsDiner && (
                        <IconButton onClick={() => this.like(chef.id)}>
                          <Icon data-test-id={"cheflikes-id"} >favorite_border</Icon>
                        </IconButton>
                      )}
                    </Typography>

                    <Typography
                      variant="subheading"
                      style={{margin: '6px 0 7px', color: '#7c7c7c', fontSize: 22, opacity: '0.8', fontWeight: 500 }}
                    >
                      {chefCuisines}
                    </Typography>
                    {/*!!chef && !!chef.hourlyPrice && <Typography
                      variant="subheading"
                      style={{margin: '6px 0 7px', color: '#000', fontSize: 18, opacity: '0.8', fontWeight: 400 }}
                    >
                      Hourly price: <span style={{ fontWeight: 500 }}>${chef.hourlyPrice}</span>
                    </Typography>*/}
                    <Grid data-test-id={"chefrtngs-id"} container style={{marginTop: 10}}>
                      <Typography
                        style={{
                          ...styles.setFont,
                          ...styles.setFontPrimary
                        }}
                      >
                        {chef.rating && chef.rating > 0 && ratingStars}
                      </Typography>
                      <Typography
                        style={{
                          ...styles.setFont,
                          ...styles.setFontPrimary,
                          marginLeft: chef.rating && chef.rating > 0 ? 7 : 0,
                        }}
                      >
                        {chefRatings}
                      </Typography>

                      <Typography
                        align={"center"}
                        style={{...styles.setFont,...{marginLeft: chef.rating && chef.rating > 0 ? 10 : 0, color: chef.reviewCount ? '#7c7c7c' : '#ff8000'}}}
                      >
                        {chef.reviewCount ? `${chef.reviewCount} Reviews` : 'No ratings'}
                      </Typography>
                    </Grid>

                  </Grid>
                </Grid>
              </Grid>

              {!isChef && <Grid item className="diner-book-now">
                <div className="chef-details-book-buttons-wrapper">
                  <div className="legend-label">Book Chef</div>
                  {!this.state.isRecurring && this.state.bookingType != CUSTOM_BOOKING &&
                  this.props.cart.length <= 0 && this.state.selectedDishCount === 0 && (
                    <Typography
                      style={{
                        ...styles.setFont,
                        marginTop: 10,
                        marginRight: 10,
                        color: 'red',
                        marginBottom: 10,
                      }}
                      align={"center"}
                    >
                      Please select one or more dishes from the list below by clicking on the <AddCircle /> button on the dish.
                    </Typography>
                  )}
                  <Button
                    className="diner-book-btn"
                    data-test-id={"chefbooknow"}
                    onClick={() => this.handleBookNow(DISHES_BOOKING)}
                  >
                    A la Carte
                  </Button>
                  
                  <Button
                    className={this.props.cart.length <= 0 ? 'diner-book-btn' : 'diner-book-btn-disabled'}
                    data-test-id={"chefbooknowcustom"}
                    onClick={() => this.handleBookNow(CUSTOM_BOOKING)}
                    disabled={this.props.cart.length > 0}
                  >
                    Custom Booking
                  </Button>
                </div>
              </Grid>}

            </Grid>


            <Divider variant={"fullWidth"} style={{margin: '40px 0'}}/>

            <Grid data-test-id={"about-id"} item style={styles.ftGrid}>
              <Grid container alignItems="flex-start">
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
                <Grid item xs={6} md={4} lg={4} xl={2} >
                  <Typography variant="h5" style={{...styles.ftText, textAlign: 'center' }} align={"center"}>
                    About
                  </Typography>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
              </Grid>
              <div style={{ maxWidth: 700, textAlign: story.length > 200 ? 'left' : 'left', margin: '0px auto' }}>
                <Typography
                  style={{
                    ...styles.ftGrid,
                    fontSize: 18,
                    color: "#000",
                    wordBreak: 'break-word',
                    ...styles.setFont,
                  }}
                >
                  <div dangerouslySetInnerHTML={this.createMarkup(story)} />
                </Typography>

                <div  data-test-id={"canceldiner"} style={{ textAlign: 'left', fontSize: 14 }}>
                  <p>
                    <strong>Cancelation Policy: </strong>
                    {chef.firstName} {chef.lastName} {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation ? ' allows ' : ' disallows '} cancelation of confirmed engagements
                    {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.penaltyCharge == 0 && ' without a fee.'}
                    {chef.cancellationPolicy && chef.cancellationPolicy.allowCancellation && chef.cancellationPolicy.penaltyCharge != 0 ? <>
                      {' '}under the following terms.
                      <ul>
                        <li style={{ textAlign: 'left' }}>No cancelation charges if canceled {chef.cancellationPolicy.timeBeforeCancellation} {chef.cancellationPolicy.timeBeforeCancellationMetric} before engagement time</li>
                        <li style={{ textAlign: 'left' }}>Any cancelations within {chef.cancellationPolicy.timeBeforeCancellation} {chef.cancellationPolicy.timeBeforeCancellationMetric} of engagement time, will result in cancelation charge of {chef.cancellationPolicy.penaltyCharge}% of booking amount.</li>
                        {chef.cancellationPolicy.allowCancellation && !!chef.cancellationPolicy.comments && <li style={{ textAlign: 'left' }}>
                          {chef.cancellationPolicy.comments ? chef.cancellationPolicy.comments.toString().charAt(0).toUpperCase() + chef.cancellationPolicy.comments.slice(1) : 'No comments'}
                        </li>}
                      </ul>
                    </> : <span></span>}
                  </p>
                </div>
              </div>
            </Grid>

            <Grid container direction="column" style={{...styles.ftGrid}}>
              <Grid container alignItems="flex-start">
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
                <Grid item xs={6} md={4} lg={4} xl={2} >
                  <Typography variant="h5" style={{fontFamily: webFont,
                    color: textBlack,
                    fontWeight: 500,
                    marginBottom: 30,
                    marginTop: 30,
                    fontSize: 30,
                    textAlign: 'center'}} align={"center"}>
                    Dishes
                  </Typography>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
              </Grid>
              <div className="profile-dish-col">
                {dishesList2}
              </div>
            </Grid>

            <Grid container style={{...styles.ftGrid, textAlign: 'center'}}>
              <Grid container alignItems="flex-start">
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }} />
                <Grid item xs={6} md={4} lg={4} xl={2} >
                  <Typography variant="h5" style={styles.ftText} align={"center"}>
                    Posts
                  </Typography>
                </Grid>
                <Grid item xs={3} md={4} lg={4} xl={5} style={{ borderBottom: '1px solid #000', marginTop: 47 }}  />
              </Grid>
            </Grid>

            <Grid container style={{...styles.ftGrid}} spacing={32}>
              <div className="profile-post-col">
                {postsList}
              </div>
            </Grid>

            <InProgressBooking
              toggleBookingDrawer={this.state.bookingDrawer}
              style={{zIndex: 9999, position: "relative"}}
              handleToggle={this.toggleBookingDrawer}
              history={this.props.history}
              chef={chef}
              isCustom={this.state.bookingType === CUSTOM_BOOKING}
            />

            {this.state.selectedDishCount > 0 && (
              <Fab
                data-test-id={"selectdish-id"}
                style={{...styles.bookingFab}}
                color={"primary"}
                onClick={this.toggleBookingDrawer}
              >
                <Icon style={{color: "#fff"}}>assignment</Icon>
              </Fab>
            )}

            <Modal
              className="booking-modal"
              open={this.state.isBookingModalOpen}
              onClose={() => this.toggleBookingModal(false)}
              aria-labelledby="booking-type-modal"
              aria-describedby="booking-type-selection-modal"
            >
              <div className="booking-type-wrapper">
                <h3>Choose your booking plan:</h3>
                <div className="booking-type-selection-wrapper">
                  <div className="type-selection-wrapper">
                    <Radio
                      checked={this.state.bookingType === CUSTOM_BOOKING}
                      name="booking-type"
                      value={CUSTOM_BOOKING}
                      onChange={() => this.selectBookingType(CUSTOM_BOOKING)}
                    />
                    <span>Custom plan <span style={{ fontSize: 12 }}>(We do allow to choose dishes in Custom plan as well)</span></span>
                  </div>

                  <div className="type-selection-wrapper">
                    <Radio
                      checked={this.state.bookingType === DISHES_BOOKING}
                      name="booking-type"
                      value={DISHES_BOOKING}
                      onChange={() => this.selectBookingType(DISHES_BOOKING)}
                    />
                    <span>Book by dishes <span style={{ fontSize: 12 }}>(One time booking only)</span></span>
                  </div>
                </div>
                <div className="booking-selection-button-wrapper">
                  <button onClick={this.chooseBookingSelection}>
                    Next
                  </button>
                </div>
              </div>
            </Modal>

            <Modal
              className="booking-modal"
              open={this.state.isCustomBookingModalOpen}
              onClose={() => this.toggleCustomBookingModal(false)}
              aria-labelledby="booking-type-modal"
              aria-describedby="booking-type-selection-modal"
            >
              <div className="booking-type-wrapper">
                <div className="booking-type-selection-wrapper">
                  <h3>Please choose your booking type:</h3>
                  <div className="type-selection-wrapper">
                    <Radio
                      checked={this.state.isRecurring}
                      name="booking-type-recurring"
                      onChange={() => this.setState({isRecurring: true})}
                    />
                    <span>Recurring</span>
                  </div>

                  <div className="type-selection-wrapper">
                    <Radio
                      checked={!this.state.isRecurring}
                      name="booking-type-recurring"
                      onChange={() => this.setState({isRecurring: false})}
                    />
                    <span>Single</span>
                  </div>
                </div>

                <div className="booking-selection-button-wrapper">
                  <button onClick={() => {
                    this.toggleCustomBookingModal(false);
                    this.toggleBookingModal(false);
                    this.toggleBookingDrawer();
                  }}>
                    Add details
                  </button>
                </div>

              </div>
            </Modal>
          </Grid>
        </div>
      </div>
    );
  }

}

const ChefDinerWithData = compose(
  graphql(GET_SAVED_CHEFS, {
    name: "savedChefs",
    options: props => ({
      variables: {
        userId: props.userId
      }
    })
  })
)(ChefDiner);

const mapStateToProps = state => {
  return {
    userId: state.auth.userId,
    isChef: state.auth.isChef,
    chef: state.chefs.chef,
    chefAvailibility: state.bookings.chefAvailibility,
    cart: state.bookings.cart,
    inProgressBooking: state.bookings.inProgressBooking,
    loading: state.chefs.chefLoading,
    pendingBooking: state.bookings.pendingBooking,
    selectedChef: state.bookings.selectedChef,
  };
};

const ChefDetailsDiner = connect(mapStateToProps)(ChefDinerWithData);
export default ChefDetailsDiner;

const styles = {
  chefImgIPad: {
    width: 150,
    height: 150
  },
  chefImgLg: {
    width: 212,
    height: 212

  },
  reviewImgLg: {
    width: 73,
    height: 73
  },
  reviewImgIpad: {
    width: 100,
    height: 100
  },
  chefImg: {
    borderRadius: "50%",
    borderWidth: 4,
    borderStyle: "solid",
    borderColor: primaryColor,
    float: "right",
    outline: "none"
  },
  chefName: {
    fontFamily: webFont,
    color: textBlack,
    weight: 500
  },
  chefCuisine: {
    fontFamily: webFont,
    color: textGrey,
    fontSize: 15,
    weight: 500,
    maxWidth: 400
  },
  createButton: {
    borderRadius: 25,
    backgroundColor: primaryColor,
    border: "none",
    minWidth: 220,
    color: "white",
    height: 49,
    fontFamily: webFont,
    textTransform: "none",
    fontSize: 20,
  },
  dishName: {
    fontFamily: webFont,
    color: textBlack,
    fontSize: 20,
    weight: 500,
    maxWidth: 400
  },
  featuredItem: {
    marginTop: 20,
    marginBottom: 10
  },
  ftGrid: {
    marginTop: 25,
    marginBottom: 10
  },
  ftText: {
    fontFamily: webFont,
    color: textBlack,
    fontWeight: 500,
    marginBottom: 10,
    marginTop: 20,
    fontSize: 30,
    textAlign: 'center'
  },
  setFont: {
    fontFamily: webFont
  },
  rateContent: {
    width: 48,
    height: 21,
    fontSize: 15
  },
  starRating: {
    width: 18,
    height: 18,
    fontSize: 18
  },
  setFontGrey: {
    color: "#7c7c7c"
  },
  setFontPrimary: {
    color: primaryColor
  },
  showBtn: {
    borderRadius: 40,
    paddingLeft: 20,
    paddingRight: 20
  },
  bookingFab: {
    position: "fixed",
    bottom: 40,
    right: 40
  },
  tick: {
    width: 28,
    height: 28,
  }
};
